import { render, staticRenderFns } from "./FeedbackFormComponent.vue?vue&type=template&id=1c1ebbbf&scoped=true&"
import script from "./FeedbackFormComponent.vue?vue&type=script&lang=ts&"
export * from "./FeedbackFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackFormComponent.vue?vue&type=style&index=0&id=1c1ebbbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1ebbbf",
  null
  
)

export default component.exports